import React, { Fragment } from "react";

export const Enviroment = () => {
    return (
        <Fragment>
            {(() => {
                if (process.env.REACT_APP_ENVIROMENT === 0) {
                    return <div className="warning dev">Dev</div>;
                } else if (process.env.REACT_APP_ENVIROMENT === 1) {
                    return <div className="warning staging">Staging</div>;
                }
            })()}
        </Fragment>
    );
};

export default Enviroment;
